(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-finalized.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-finalized.js');

'use strict';

const {
  useMemo
} = React;
const {
  clx
} = svs.components.lbUtils;
const {
  CompetitionLogo,
  LoginButton,
  TrixaButton,
  VisitGameButton
} = svs.components.marketplaceCompetition.overviewHero.common;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  ordinalNumber
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  useMobileQuery,
  useTrixa
} = svs.components.marketplaceCompetition.overviewHero.hooks;
const {
  IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const UserNotLoggedIn = _ref => {
  let {
    competition
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Logga in f\xF6r att se dina resultat")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let {
    competition,
    compName,
    isMobile,
    showTrixa
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Du deltar inte i \xE5rets ".concat(compName, ",")), !isMobile && React.createElement("span", null, "men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  let {
    competition,
    compName
  } = _ref3;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "N\xE4sta omg\xE5ng \xF6ppnar snart f\xF6r spel."), React.createElement("span", null, "Gl\xF6m inte att l\xE4mna in ditt spel i tid."))));
};
const UserHasBet = _ref4 => {
  let {
    competition
  } = _ref4;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "R\xE4tta ditt spel f\xF6r"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "R\xE4tta ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, currentGameTitle)), React.createElement(VisitGameButton, {
    competition: competition
  }));
};
const CompetitionClosedDrawFinalized = _ref5 => {
  let {
    branding,
    competition,
    userState
  } = _ref5;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const [showTrixa, Trixa] = useTrixa();
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-finalized"
    });
  }
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-finalized', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawFinalized', CompetitionClosedDrawFinalized);

 })(window);